import {
  AppWindow,
  CreditCard,
  KeyRound,
  LucideIcon,
  ShieldCheck,
  Unlock,
  Users,
} from 'lucide-react';

import { DecryptText } from '@components/patterns/DecryptText';

import css from './styles.module.css';

export function UpgradeFeatures() {
  return (
    <ul className={css.features}>
      <Feature icon={CreditCard} title="Card Collection" />
      <Feature
        icon={ShieldCheck}
        title="3D Secure"
        description="$0.03 per successful authentication"
      />
      <Feature
        icon={KeyRound}
        title="Network Tokens"
        description="$0.03 per network token event"
      />
      <Feature
        icon={Unlock}
        title="Unlimited Decrypts"
        description="$0.005 per decrypt"
      />
      <Feature
        icon={AppWindow}
        title="Unlimited Production Apps"
        description="No cap on live apps"
      />
      <Feature
        icon={Users}
        title="Unlimited Team Members"
        description="No cap on seats"
      />
    </ul>
  );
}

type FeatureProps = {
  icon: LucideIcon;
  title: string;
  description?: string;
};

function Feature({ icon: Icon, title, description }: FeatureProps) {
  return (
    <li>
      <span className={css.featureIcon}>
        <Icon aria-hidden size={14} strokeWidth={1.75} />
      </span>
      <div>
        <h5>
          <DecryptText>{title}</DecryptText>
        </h5>
        {description && (
          <p>
            <DecryptText>{description}</DecryptText>
          </p>
        )}
      </div>
    </li>
  );
}
